export const getFileName = (url: string) => {
  const urlObject = new URL(url);
  const path = urlObject.pathname;
  const pathComponents = path.split('/');
  const fileName = pathComponents[pathComponents.length - 1];
  return fileName;
};
